





























































import { IQuoteData, Quote } from '@/models/quote';

import Vue from 'vue';
import { mapActions } from 'vuex';

import moment from 'moment';
import ALDialog from '../core/Dialog/ALDialog.vue';
import { ErrorManager } from '@/models/error';
import ErrorAlert from '../common/ErrorAlert.vue';

export default Vue.extend({
  name: 'RevisionHistoryDialog',

  components: { ALDialog, ErrorAlert },

  data: () => ({
    quotes: [] as Quote[],
    revisionDialog: false,
    revisionLoading: false,

    sortBy: 'revision',
    sortDesc: true,

    revisionHeaders: [
      {
        text: 'No.',
        align: 'center',
        width: 70,
        sortable: false,
        value: 'revision'
      },
      {
        text: 'Created',
        align: 'start',
        sortable: false,
        value: 'created_at'
      },
      {
        text: 'Modified',
        align: 'start',
        sortable: false,
        value: 'updated_at'
      },
      {
        text: 'Owner',
        sortable: false,
        value: 'owner'
      },
      {
        text: 'State',
        align: 'center',
        sortable: false,
        value: 'state'
      },
      {
        text: 'Current',
        align: 'center',
        sortable: false,
        value: 'latest'
      }
    ],

    errorMessage: '',
    detailErrorMessage: ''
  }),

  methods: {
    moment,

    ...mapActions({
      fetchQuoteRevisions: 'quote/fetchQuoteRevisions'
    }),

    getLatestRevision(id: number) {
      this.fetchQuoteRevisions(id).then((quotes: IQuoteData[]) => {
        this.quotes = quotes.map(data => new Quote(data));
        this.$emit('updatedLatest', id);
      });
    },

    goToRevision(quote: Quote) {
      this.$router.push({
        name: 'quote-revision-detail',
        params: {
          quoteId: String(quote.number),
          quoteRevision: String(quote.revision)
        }
      });
    },

    open(quote: Quote) {
      this.revisionLoading = true;
      this.clearAllErrors();
      this.fetchQuoteRevisions(quote.number)
        .then((quotes: IQuoteData[]) => {
          this.quotes = quotes.map(data => new Quote(data));
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.revisionLoading = false;
        });
      this.revisionDialog = true;
    },

    clearAllErrors(): void {
      this.errorMessage = '';
    },

    close() {
      this.revisionDialog = false;
      this.revisionLoading = false;
    }
  }
});
